

export const CategoryMolecules = [];